import { ElementType } from "@/constants/tagular/main";

/**
 * Common verified certificate tag configuration
 */
export const VERIFIED_CERTIFICATE_TAG = {
  text: "Verified Certificate",
  color: "fern" as const,
  borderless: true,
  icon: "certificate" as const,
};

/**
 * Element event configurations for multi-purchase cart components
 */
export const MULTI_PURCHASE_CART_EVENT_CONFIGS = {
  modal: {
    elementType: ElementType.Modal,
    htmlId: "modal",
    location: "abandoned-cart-modal",
    name: "pop-up-modal",
    text: "In your cart",
  },
  modalCheckoutButton: {
    elementType: ElementType.Button,
    htmlId: "modal",
    location: "abandoned-cart-modal",
    name: "checkout-click",
    text: "Go to cart",
  },
  modalCloseButton: {
    elementType: ElementType.Modal,
    htmlId: "modal",
    location: "abandoned-cart-modal",
    name: "exit-button",
    text: "Exit Modal",
  },
  modalContinueButton: {
    elementType: ElementType.Button,
    htmlId: "modal",
    location: "abandoned-cart-modal",
    name: "continue-browsing-click",
    text: "Continue Browsing",
  },
  cartPopupButton: {
    elementType: "Cart" as const,
    htmlId: "cart",
    location: "nav-bar",
    name: "checkout-click",
    // text will be provided dynamically
  },
} as const;
